import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { AllLoaded } from "../state/selectors";

declare const _paq: any[];

export function AnalyticsTracker() {
	const allLoaded = useRecoilValue(AllLoaded);

	useEffect(() => {
		if (!allLoaded) return;
		// Your analytics tracking code here
		console.log(
			"All page elements are loaded, fire analytics event",
			allLoaded,
		);
		const timer = setTimeout(() => {
			if (typeof _paq !== "undefined") {
				_paq.push(["HeatmapSessionRecording::enable"]);
				_paq.push(["HeatmapSessionRecording::captureInitialDom", 3]);
			}
		}, 1200);

		return () => clearTimeout(timer);
	}, [allLoaded]);

	return <></>; // This component doesn't render anything
}
